'use client';

import { useTranslations } from 'next-intl';
import type { LinkNavigationMenuItemProps } from '../../../NavigationMenu/components/NavigationMenuItem/types';
import { NavigationMenu } from '../../../NavigationMenu/NavigationMenu';

type CloseAccountSectionProps = {
  namespace: string;
  className?: string;
  onCloseAccount: () => void;
};

function CloseAccountSection({ namespace, className, onCloseAccount }: CloseAccountSectionProps) {
  const t = useTranslations(namespace);

  const closeMyAccountItems: LinkNavigationMenuItemProps[] = [
    {
      label: t('close_my_account'),
      labelClassName: 'paragraph-strong',
      variant: 'link',
      onClick: onCloseAccount,
      'data-testid': 'close-account-row',
    },
  ];

  return (
    <div data-testid="close-account-section" data-track-section="Close Account">
      <NavigationMenu variant="secondary" items={closeMyAccountItems} className={className} />
    </div>
  );
}

export { CloseAccountSection };
